import { useCssVars as _useCssVars, unref as _unref } from 'vue'
import {computed} from 'vue'

export default {
  __name: 'empty',
  props: {
  bg: {
    type: String,
    default: 'assets/bg-pattern-decorative.png'
  },
  bgSize: {
    type: String,
    default: 'cover'
  },
  circleSize: {
    type: String,
    default: '12rem'
  },
  icon: {
    type: String,
    default: 'doc-icon'
  },
  bordered: {
    type: Boolean,
    default: true
  },
  shadow: {
    type: Boolean,
    default: false
  }
},
  setup(__props, { expose: __expose }) {
  __expose();

_useCssVars(_ctx => ({
  "85700a66-c_bg": (c_bg.value),
  "85700a66-bgSize": (__props.bgSize),
  "85700a66-circleSize": (__props.circleSize)
}))

const props = __props
const c_bg = computed(() => `url(${props.bg}) no-repeat center calc(50%)`)

const __returned__ = { props, c_bg, computed }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

}